import api from "@/api";
import converters from "@/converters";
import type { ICalendarItem } from "@/stories/dashboard/CalendarItem/CalendarItem.vue";
import type { DateRange } from "@/types";

const getActivities = async (range: DateRange): Promise<ICalendarItem[]> => {
  const response = await api.activities.getActivities(range);
  return response.edges.map(converters.calendar.fromActivity);
};

const getMeals = async (range: DateRange): Promise<ICalendarItem[]> => {
  const response = await api.meals.getMeals(range);
  return response.edges.map(converters.calendar.fromMeal);
};

const getMeetings = async (range: DateRange): Promise<ICalendarItem[]> => {
  const response = await api.meetings.getMeetings(range);
  return response.edges.map(converters.calendar.fromMeeting);
};

const getBookings = async (range: DateRange): Promise<ICalendarItem[]> => {
  const response = await api.bookings.getBookings(range);
  return response.edges.map(converters.calendar.fromBooking);
};

const getAll = async (range: DateRange): Promise<ICalendarItem[]> => {
  // Fetch all of calendar items from API
  const responses = await Promise.all([
    getActivities(range),
    getMeals(range),
    getMeetings(range),
    getBookings(range),
  ]);

  // It should be a flat list
  return responses.flat();
};

export default {
  getAll,
};
